import React from 'react';
import {
  Divider,
  Input as AntdInput,
  InputProps,
  Select,
  SelectProps
} from 'antd';
import styled from '@emotion/styled';
import { SearchOutlined } from '@ant-design/icons';

const StyledInput = styled(AntdInput)`
  border-radius: 4px;
  width: 100%;
`;

type SearchWithOptionProps = {
  inputProps?: InputProps;
  selectProps: SelectProps;
};

const Input = (props: InputProps) => {
  return <StyledInput {...props}></StyledInput>;
};

const StyledSelect = styled(Select)`
  z-index: 1;
  border: none;
  box-shadow: none;
  &.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    border: none;
    box-shadow: none;
  }
  &:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
    box-shadow: none;
  }
`;

const StyledGroup = styled(AntdInput.Group)`
  &.ant-input-group {
    display: flex;
    align-items: center;
    border: 1px solid #d9d9d9;
    .ant-input-affix-wrapper {
      border: none;
    }
  }

  &.ant-input-group.ant-input-group-compact.focused {
    border: 1px solid #40a9ff;
    .ant-input-affix-wrapper {
      &:hover {
        border: none;
        box-shadow: none;
      }
      border: none;
      box-shadow: none;
    }
  }
`;
const StyledDivider = styled(Divider)`
  width: 1px;
  min-height: 20px;
  margin-right: 0;
`;
const SearchWithOptions = ({
  selectProps,
  inputProps
}: SearchWithOptionProps) => {
  const [focused, setFocused] = React.useState(false);
  return (
    <StyledGroup
      className={focused ? 'focused' : ''}
      onFocus={() => {
        setFocused(true);
      }}
      onBlur={() => {
        setFocused(false);
      }}
    >
      <Input prefix={<SearchOutlined></SearchOutlined>} {...inputProps}></Input>
      <StyledDivider type="vertical"></StyledDivider>
      <StyledSelect {...(selectProps as any)}></StyledSelect>
    </StyledGroup>
  );
};

Input.Search = AntdInput.Search;
Input.TextArea = AntdInput.TextArea;
Input.SearchWithOptions = SearchWithOptions;
export default Input;
